export interface colorPair {
  main: string;
  border: string;
}

export const ChartBarsColors = [
  {
    main: 'rgba(150, 150, 150, 0.2)',
    border: 'rgb(150, 150, 150)',
  },
  {
    main: 'rgba(255, 99, 132, 0.2)',
    border: 'rgb(255, 99, 132)',
  },
  {
    main: 'rgba(255, 159, 64, 0.2)',
    border: 'rgb(255, 159, 64)',
  },
  {
    main: 'rgba(255, 205, 86, 0.2)',
    border: 'rgb(255, 205, 86)',
  },
  {
    main: 'rgba(75, 192, 192, 0.2)',
    border: 'rgb(75, 192, 192)',
  },
  {
    main: 'rgba(54, 162, 235, 0.2)',
    border: 'rgb(54, 162, 235)',
  },
  {
    main: 'rgba(54, 162, 235, 0.2)',
    border: 'rgb(153, 102, 255)',
  },
];
